module.exports = __webpack_public_path__ + "img/halfrate.d5ebe4a9.svg";